import { ExperimentNonPaddedRoutes } from "@src/routes/loggedIn/standardNoPaddingRoutes/experimentNonPaddedRoutes";
import { OpportunityAuditRoutes } from "@src/routes/loggedIn/standardNoPaddingRoutes/opportunityAuditRoutes";
import { PersonalizationNonPaddedRoutes } from "@src/routes/loggedIn/standardNoPaddingRoutes/personalizationNonPaddedRoutes";
import { ReverseProxyTestRoutes } from "@src/routes/loggedIn/standardNoPaddingRoutes/reverseProxyTestRoutes";
import { RulesRoutes } from "@src/routes/loggedIn/standardNoPaddingRoutes/rulesRoutes";
import { AiRoutes } from "@src/routes/loggedIn/standardPageRoutes/aiRoutes";

export const StandardNoPaddingRoutes = [
  ...PersonalizationNonPaddedRoutes,
  ...ExperimentNonPaddedRoutes,
  ...ReverseProxyTestRoutes,
  ...RulesRoutes,
  ...OpportunityAuditRoutes,
];
